import { getVersion } from 'maplibre-gl';
import 'maplibre-gl/dist/maplibre-gl.css';

export function getMapLibreVersion(): string {
  return getVersion();
}
